import React, { useState, useCallback, useEffect } from "react";
import { Idea } from "../../../model/types";
import { Tags } from "@/core/components/tags/Tags";
import { imageList } from "@/core/utils/imageList";

interface PartnershipListProps {
  idea: Idea;
  onRemoveMember: (memberId: string) => void;
  onMakeCoordinator: (partnerId: string) => void;
  removingMember: string | null;
  makingCoordinator: string | null;
}

export const PartnershipList: React.FC<PartnershipListProps> = ({
  idea,
  onRemoveMember,
  onMakeCoordinator,
  removingMember,
  makingCoordinator,
}) => {
  const [expandedPartners, setExpandedPartners] = useState<Set<string>>(
    new Set(),
  );

  useEffect(() => {
    // console.log(idea, "idea");
  }, []);

  const togglePartnerExpansion = useCallback((partnerId: string) => {
    setExpandedPartners((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(partnerId)) {
        newSet.delete(partnerId);
      } else {
        newSet.add(partnerId);
      }
      return newSet;
    });
  }, []);

  if (!idea?.partnership) {
    return (
      <div className="no-partnership">
        <p>No partnership information available.</p>
      </div>
    );
  }

  const partnershipData = idea.partnership;

  if (
    !partnershipData ||
    (typeof partnershipData === "object" &&
      Object.keys(partnershipData).length === 0)
  ) {
    return (
      <div className="no-partnership">
        <p>No partnership information available.</p>
      </div>
    );
  }

  const partnershipArray = Array.isArray(partnershipData)
    ? partnershipData
    : Object.values(partnershipData as Record<string, any>);

  useEffect(() => {
    // console.log(partnershipArray, "partnershipArray");
  }, []);
  if (partnershipArray.length === 0) {
    return (
      <div className="no-partnership">
        <p>No partnership information available.</p>
      </div>
    );
  }

  return (
    <div className="partnership-list">
      {partnershipArray.map((partnershipEntry: any, index: number) => {
        const partner = partnershipEntry?.partner || partnershipEntry;
        const membersData = partnershipEntry?.members || {};

        const members =
          typeof membersData === "object" && membersData !== null
            ? Object.values(membersData)
            : Array.isArray(membersData)
              ? membersData
              : [];

        if (!partner) return null;

        const isExpanded = expandedPartners.has(
          partner?.id || `partner-${index}`,
        );

        return (
          <div key={partner?.id || index} className="partnership-item">
            <div
              className="partnership-header"
              style={{
                cursor: members.length > 0 ? "pointer" : "default",
              }}
              onClick={() =>
                members.length > 0 &&
                togglePartnerExpansion(partner?.id || `partner-${index}`)
              }
            >
              <div className="partner-info">
                {members.length > 0 && (
                  <div
                    className="expandIcon"
                    style={{
                      transform: isExpanded ? "rotate(0deg)" : "rotate(-90deg)",
                      transition: "transform 0.2s",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M5 7.5L10 12.5L15 7.5"
                        stroke="#414651"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                )}
                <div className="partner-logo-wrapper">
                  <img
                    src={
                      partner.logo_uri && partner.logo_uri !== ""
                        ? partner.logo_uri
                        : imageList.noOrgimage
                    }
                    alt={partner?.title || partner?.name || "Partner"}
                    className="partner-logo"
                  />
                </div>
                <div className="partner-details">
                  <div className="partner-name">
                    {partner?.title || partner?.name || "Unknown Partner"} (
                    {members.length})
                  </div>
                  <div className="partner-type">
                    <span className="type">
                      {partner?.partner_type?.name || ""}
                    </span>
                    <span className="location">
                      {partner?.country?.name || partner?.country || ""}
                    </span>
                    {idea.is_owner && partnershipEntry?.is_owner && (
                      <Tags type="custom" text="Owner" />
                    )}
                  </div>
                </div>
              </div>
              <div className="partnership-status">
                <span className="status-badge coordinator">
                  {partnershipEntry.is_owner ? "Owner" : "Guest"}
                  {
                    idea.is_owner && partnershipEntry?.is_owner ? (
                      <div className="partner-action">Coordinator</div>
                    ) : null
                    // (
                    //   idea?.status.toLowerCase() === "published" &&
                    //   idea.is_owner &&
                    //   !partnershipEntry?.is_owner && (
                    //     <div className="partner-action">
                    //       Partner{" "}
                    //       <div
                    //         className="partner-action-btn"
                    //         onClick={(e) => {
                    //           e.stopPropagation();
                    //           onMakeCoordinator(partner.id);
                    //         }}
                    //       >
                    //         {makingCoordinator === partner.id
                    //           ? "Making coordinator..."
                    //           : "Make coordinator"}
                    //       </div>
                    //     </div>
                    //   )
                    // )
                  }
                </span>
              </div>
            </div>

            {members.length > 0 && isExpanded && (
              <div className="members-list">
                {members.map((member: any, memberIndex: number) => (
                  <div key={member?.id || memberIndex} className="member-item">
                    <div className="member-avatar">
                      <img
                        src={
                          member.logo_uri && member.logo_uri !== ""
                            ? member.logo_uri
                            : imageList.noimage
                        }
                        alt={member?.firstname || member?.username || "Member"}
                      />
                    </div>
                    <div className="member-info">
                      <div className="member-info-texts">
                        <div className="member-name">
                          {member?.firstname && member?.lastname
                            ? `${member.firstname} ${member.lastname}`
                            : member?.username || "Unknown Member"}
                        </div>
                        <div className="member-role">
                          {member?.job_title || ""}
                        </div>
                      </div>
                    </div>
                    <div className="member-actions">
                      {/* {idea?.ownership && partnershipEntry?.is_owner && (
                        <Tags type="custom" text={"Owner"} />
                      )} */}
                      {idea?.state.toLowerCase() === "approved" &&
                        idea.is_owner &&
                        !partnershipEntry?.is_owner && (
                          <button
                            className="btn-remove"
                            onClick={() => onRemoveMember(member.id)}
                            disabled={removingMember === member.id}
                          >
                            {removingMember === member.id
                              ? "Removing..."
                              : "Remove"}
                          </button>
                        )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
